import { useMutation, useQuery } from "react-query";

import { Type_User } from "src/types/user";

import { isTokenValid, login, logout } from "./service";

export const mutationLogin = () => {
    return useMutation({
        mutationFn: (body: Omit<Type_User, "id">) => login(body),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationLogin");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationLogin", err);
            return err;
        },
    });
};

export const useIsTokenValid = (token: string) => {
    return useQuery({
        queryKey: ["isTokenValid", token],
        queryFn: () => {
            return isTokenValid(token);
        },
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useIsTokenValid");
            }
            return data.data;
        },
        onError: (err: any) => {
            return err;
        },
    });
};

export const mutationLogout = () => {
    return useMutation({
        mutationFn: (token: string) => logout(token),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationLogout");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationLogout", err);
            return err;
        },
    });
};
